import MigrationMessagingBanner from 'svh-conversations-settings-lib/migration/components/MigrationMessagingBanner';
import { useConnectedEmailAccountByChannelInstanceId } from 'svh-conversations-settings-lib/migration';
import { getMigrationStatusUrl } from '../../../urls/getHelpDeskMigrationUrl';
import { jsx as _jsx } from "react/jsx-runtime";
const EmailMigrationBanner = ({
  channel,
  inboxId
}) => {
  const {
    channelInstanceId
  } = channel;
  const {
    connectedEmailAccount
  } = useConnectedEmailAccountByChannelInstanceId(channelInstanceId);
  if (!connectedEmailAccount) {
    return null;
  }
  return /*#__PURE__*/_jsx(MigrationMessagingBanner, {
    channel: channel,
    viewStatusRoute: getMigrationStatusUrl(inboxId, 'email', connectedEmailAccount.id)
  });
};
EmailMigrationBanner.displayName = 'EmailMigrationBanner';
export default EmailMigrationBanner;